module.exports = __webpack_public_path__ + "media/images/hodgepodge-aeed2cd6439ea4f63dab1807df5918fd.png";